// PR-54: Capacitor app-state listener — fires on resume from background.
//
// Why we need this: when the iOS app is backgrounded the SSE / EventSource
// connection to /api/projects/.../events dies (iOS suspends networking).
// On resume, the connection doesn't auto-reconnect cleanly, so the user
// sees stale data. We listen for the foreground transition and re-pull
// the project's data manually.
//
// On web the helper is a no-op.

import { App } from '@capacitor/app'
import type { PluginListenerHandle } from '@capacitor/core'
import { isCapacitor } from './platform'

export function listenToAppResume(onResume: () => void): () => void {
  if (!isCapacitor()) return () => {}
  let handle: PluginListenerHandle | undefined
  App.addListener('appStateChange', (state) => {
    if (state.isActive) onResume()
  }).then((h) => {
    handle = h
  })
  return () => {
    handle?.remove()
  }
}
